import { render, staticRenderFns } from "./upairy-tabs.vue?vue&type=template&id=555cdf46&scoped=true&"
import script from "./upairy-tabs.vue?vue&type=script&lang=js&"
export * from "./upairy-tabs.vue?vue&type=script&lang=js&"
import style0 from "./upairy-tabs.vue?vue&type=style&index=0&id=555cdf46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555cdf46",
  null
  
)

export default component.exports